export const HELP_MODAL_LINKS = [
  {
    links: [
      { id: 0, name: 'ユーザーガイド', url: '' },
      { id: 1, name: '利用規約', url: '/pdf/riyoukiyaku.pdf' },
      { id: 2, name: '動作環境一覧', url: '/pdf/dousakankyou.pdf' },
    ],
  }
];

export default HELP_MODAL_LINKS;
